import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';
import { DisplayableFile } from '../interfaces/displayable-file.interface';
import { MedigapRequiredDocumentUploadStateStructure, MEDIGAP_FORM_DOCUMENT_UPLOAD_REDUCER_NAME } from '../medigap-form.doc-upload.reducer';
import { LINE_OF_BUSINESS_ENUM } from '@ptl/account-management';

@FormComponentLookup('form-required-docs-upload-review')
@Component({
  selector: 'app-required-docs-upload-review',
  templateUrl: './required-docs-upload-review.component.html',
  styleUrl: './required-docs-upload-review.component.scss',
  standalone: false
})
export class RequiredDocsUploadReviewComponent extends FormEntryComponentClass {

  fileDisplayArray: DisplayableFile[] = [];

  constructor() {
    super();
  }

  ngOnInit(): void {
    if (!this.entry?.custom?.lob || this.entry.custom.lob === LINE_OF_BUSINESS_ENUM.SENIOR) {
      this.loadMedigapDocuments();
    }
  }

  loadMedigapDocuments() {
    const medigapFormDocumentUploadState: MedigapRequiredDocumentUploadStateStructure
      = this.reducerUtilityService.getComponentStates()[MEDIGAP_FORM_DOCUMENT_UPLOAD_REDUCER_NAME];

    if (medigapFormDocumentUploadState.documents.length > 0) {
      this.fileDisplayArray = medigapFormDocumentUploadState.documents.map(d => d.displayableFileObj);
    }
  }

  editQuestion(): void {
    this.emitCustomPage(this.entry.pageNumber);
  }
}